import React, { useEffect, useState } from "react";
import ForgotImg from "../../assets/img/vector/forgot-password.png";
import { useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { message } from "antd";

const ResetPassword = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const emailFromQuery = searchParams.get("email") || "";
  const tokenFromQuery = searchParams.get("token");

  const [email, setEmail] = useState(emailFromQuery);
  const [password, setPassword] = useState("");
  const [password_confirmation, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const fieldWidth = window.innerWidth < 1200 ? "300px" : "520px";

  const token = tokenFromQuery || Cookies.get("token");
  const passwordsDoNotMatch =
    password.length > 0 &&
    password_confirmation.length > 0 &&
    password !== password_confirmation;
  const invalidTokenOrEmailMessage =
    "This password reset link may have already been used or expired. Please go back to your email inbox and make sure you are clicking the link from the latest password reset email. If you requested multiple reset emails, scroll to the newest one and use that link.";

  useEffect(() => {
    if (emailFromQuery) {
      setEmail(emailFromQuery);
    }
  }, [emailFromQuery]);

  async function SendLink(event) {
    console.log("Bearer " + token);
    event.preventDefault();

    if (!token) {
      setError(
        "Reset link is invalid or expired. Please request a new password reset link."
      );
      return;
    }

    if (passwordsDoNotMatch) {
      setError("The 2 typed passwords are not the same.");
      return;
    }

    setError("");
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/auth/forgotPassword/reset",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            token,
            email: email.trim(),
            password,
            password_confirmation,
          }),
        }
      );
      const data = await response.json().catch(() => ({}));

      console.log("response value", response);
      console.log("data value", data);

      if (response.ok) {
        Cookies.remove("token");
        message.success("Password reset successfully");
        history.push("/auth/signin");
        return;
      }

      if (data?.message === "Invalid token or email") {
        setError(invalidTokenOrEmailMessage);
      } else if (response.status === 404) {
        setError("User with given email does not exist");
      } else {
        setError(
          data?.message ||
            "Password reset failed. Please request a new password reset link and try again."
        );
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
    }

    // Make API call to confirm password
    // setIsConfirmed(true);
  }

  return (
    <React.Fragment>
      <div className="auth-header">
        <div className="auth-header-logo forgot-img">
          <img src={ForgotImg} alt="" className="auth-header-logo-img" />
        </div>
      </div>
      <div className="auth-body">
        <form className="auth-form-validation" onSubmit={SendLink}>
          <h1 className="auth-header-title-reset-header">Reset Password</h1>
          {/* <p className="auth-header-subtitle-forgot-subtitle">
          Enter your email and we'll send you intructions to reset your password
        </p> */}

          <div className="input-field">
            <label htmlFor="email" className="input-label">
              Email address
            </label>
            <input
              type="email"
              className="input-control"
              id="email"
              placeholder="example@gmail.com"
              autoComplete="off"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>
          <div className="input-field">
            <label htmlFor="password" className="input-label">
              Password
            </label>
            <div style={{ position: "relative", width: fieldWidth }}>
              <input
                type={visible ? "text" : "password"}
                className="input-control"
                id="password"
                placeholder=" Password"
                autoComplete="off"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
                style={{ paddingRight: "38px" }}
              />
              <span style={{ position: "absolute", right: 12, bottom: 8 }}>
                {visible ? (
                  <EyeTwoTone onClick={() => setVisible(false)} />
                ) : (
                  <EyeInvisibleOutlined onClick={() => setVisible(true)} />
                )}
              </span>
            </div>
          </div>
          <div className="input-field">
            <label htmlFor="passwordConfirmation" className="input-label">
              Password Confirmation
            </label>
            <div style={{ position: "relative", width: fieldWidth }}>
              <input
                type={visible2 ? "text" : "password"}
                className="input-control"
                id="passwordConfirmation"
                placeholder=" Password Confirmation"
                autoComplete="off"
                value={password_confirmation}
                onChange={(event) => setConfirmPassword(event.target.value)}
                required
                style={{ paddingRight: "38px" }}
              />
              <span style={{ position: "absolute", right: 12, bottom: 8 }}>
                {visible2 ? (
                  <EyeTwoTone onClick={() => setVisible2(false)} />
                ) : (
                  <EyeInvisibleOutlined onClick={() => setVisible2(true)} />
                )}
              </span>
            </div>
            {passwordsDoNotMatch && (
              <p
                style={{
                  color: "#d93025",
                  width: window.innerWidth < 1200 ? "100%" : fieldWidth,
                  marginTop: "10px",
                  marginBottom: "0",
                }}
              >
                The 2 typed passwords are not the same.
              </p>
            )}
          </div>
          <div
            className="input-field"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <button
              type="submit"
              className="btn-submit-forgot-password"
              style={{
                padding: "8px 25px",
                width: window.innerWidth < 1200 ? "100%" : "520px",
                opacity: passwordsDoNotMatch ? 0.6 : 1,
                cursor: passwordsDoNotMatch ? "not-allowed" : "pointer",
              }}
              disabled={passwordsDoNotMatch}
            >
              Reset Password
            </button>
            {error && (
              <p
                style={{
                  color: "red",
                  width: window.innerWidth < 1200 ? "100%" : "520px",
                  marginTop: "20px",
                }}
              >
                {error}
              </p>
            )}
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
